/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineapply1Inputs */

const en_refineapply1 = /** @type {(inputs: Refineapply1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refine with AI`)
};

const de_refineapply1 = /** @type {(inputs: Refineapply1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit KI verfeinern`)
};

/**
* | output |
* | --- |
* | "Refine with AI" |
*
* @param {Refineapply1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineapply1 = /** @type {((inputs?: Refineapply1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineapply1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineapply1(inputs)
	return de_refineapply1(inputs)
});
export { refineapply1 as "refineApply" }